import { Avatar, Box, Flex, Stack } from '@chakra-ui/react';
import React from 'react';

interface IEditLog {
  isLast: boolean;
  name: string;
  heading: React.ReactNode | string;
  children?: React.ReactNode | string;
}

const EditLog: React.FC<IEditLog> = ({ isLast, name, heading, children }) => {
  return (
    <Box
      position="relative"
      pb={4}
      _before={{
        content: `""`,
        h: 'full',
        w: '2px',
        bg: 'gray.400',
        display: isLast ? 'none' : 'block',
        position: 'absolute',
        // Offset of the avatar
        top: '48px',
        // Offset of the avatar combined with the width of the bar
        left: '23px',
      }}
    >
      <Flex alignItems="flex-start" gridGap={2} justifyContent="flex-start" w="full">
        <Avatar
          border="3px solid"
          borderColor="secondary.500"
          color="secondary.500"
          bg="secondary.100"
          fontWeight="bold"
          name={name}
        />
        <Stack gridGap={2} w="full">
          {heading}
          <Box w="full">{children}</Box>
        </Stack>
      </Flex>
    </Box>
  );
};

export default EditLog;
